import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/xc/dev/digimaker-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import List from './List';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "list"
    }}>{`List`}</h1>
    <p>{`List is the component showing all under contents. It can be used for both location content(eg. article) and non-location content(eg. image)`}</p>
    <p>{`A typical List use includes `}<inlineCode parentName="p">{`columns`}</inlineCode>{`, `}<inlineCode parentName="p">{`sort`}</inlineCode>{`, `}<inlineCode parentName="p">{`sort_default`}</inlineCode>{`, `}<inlineCode parentName="p">{`pagination`}</inlineCode>{`.`}</p>
    <p>{`A list can have actions above the records(see `}<inlineCode parentName="p">{`actions`}</inlineCode>{` property), or in row(see `}<inlineCode parentName="p">{`row_actions`}</inlineCode>{` property). For more about actions see `}<a parentName="p" {...{
        "href": "./actions/Config"
      }}>{`Config actions`}</a>{`, `}<a parentName="p" {...{
        "href": "./actions/Implement"
      }}>{`Implement an action`}</a></p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//Show article under 10, with "name", "published", "modified" columns
const listOption = {
   contenttype: "article"
   columns: ["name", "published", "modified"],
   sort_default: ["priority desc", "modified desc"],
   };
<List id={10} {...listOption} />

//Action with actions - link and component
const articleActions = [
   {"link":"/main/edit/{id}", "name":"edit"},
   (actionProps:ActionProps)=><Copy {...actionProps} />
   ];
<List id={10} {...listOption} row_actions={articleActions} />

`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props table={true} isToggle={true} of={List} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'<List />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      List,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
   <List mdxType="List" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      